import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { MiddleTruncatedText } from './text.middle-truncated.js';
import { PlainText } from './text.plain.js';
import { TruncatedText } from './text.truncated.js';

/**
 * Internal shared root for every `Text.*` element. Dispatches between the plain, truncated, and
 * middle-truncated implementations based on `truncate`, so non-truncating elements don't pay the
 * cost of the truncation hooks.
 */
// eslint-disable-next-line react/display-name -- internal helper, not exposed in public API
const TextBase = forwardRef(({ truncate, hideTooltip, onTruncationChange, children, ...props }, ref) => {
    if (truncate === 'middle' && typeof children === 'string') {
        return (jsx(MiddleTruncatedText, { ...props, ref: ref, hideTooltip: hideTooltip, onTruncationChange: onTruncationChange, children: children }));
    }
    if (truncate != null) {
        // Non-string children with `truncate="middle"` already missed the branch above; fall back
        // to end-truncation here so callers don't lose the visual treatment entirely.
        truncate = truncate === 'middle' ? 'end' : truncate;
        return (jsx(TruncatedText, { ...props, ref: ref, truncate: truncate, hideTooltip: hideTooltip, onTruncationChange: onTruncationChange, children: children }));
    }
    return (jsx(PlainText, { ...props, ref: ref, children: children }));
});

export { TextBase };
//# sourceMappingURL=text.base.js.map
